import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { SocialBarPopulatedExample } from './SocialBarExamples';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { socialBarDriverFactory } from './SocialBar.driver';
import { SocialBarIconTestHook } from './consts';

visualize('SocialBar', () => {
  story('render', () => {
    snap('default', <SocialBarPopulatedExample />);
    snap('focus', (done) => (
      <VisualAsync
        driverFactory={socialBarDriverFactory}
        onDone={done}
        action={async (driver) => {
          const socialBarIconDriver = await driver.socialBarIconAt(
            2,
            SocialBarIconTestHook,
          );
          await socialBarIconDriver.focus();
        }}
      >
        <SocialBarPopulatedExample />
      </VisualAsync>
    ));
    snap(
      'narrow',
      <div style={{ width: '200px' }}>
        <SocialBarPopulatedExample />
      </div>,
    );
    snap(
      'dark background',
      <div style={{ background: '#222' }}>
        <SocialBarPopulatedExample theme="dark" />
      </div>,
    );
    snap(
      'mobile',
      <TPAComponentsProvider value={{ mobile: true }}>
        <SocialBarPopulatedExample />
      </TPAComponentsProvider>,
    );
    snap(
      'mobile narrow',
      <TPAComponentsProvider value={{ mobile: true }}>
        <div style={{ width: '320px' }}>
          <SocialBarPopulatedExample />
        </div>
      </TPAComponentsProvider>,
    );
  });
});
